/**************************************************
 * Nombre:       Seccion_Tours
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Tours_Portada from "./Componentes/Tours_Portada";
import Tours_Catalogo from "./Componentes/Tours_Catalogo";
import Asesorate from "./Componentes/Asesorate";
import Equipo from "./Componentes/Equipo";
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";
import {useEffect, useState} from "react";
import useRecuperarColleccionListeningProg from "../../Servicios/BD/useRecuperarColleccionListeningProg";
import {where} from "firebase/firestore";
import {useParams} from "react-router-dom";
import {CATEGORIAS} from "../../Constantes";
import {irArriba} from "../../Utilidades/irArriba";

const Seccion_Tours = () => {
    const {sCell, masSM} = useResponsive()
    const parms = useParams()
    const [seleccionado, setSeleccionado] = useState({nombre: 'Todos'})
    const [wheres, setWheres] = useState([where('categoria', '==', 'Mar')])
    const {data, cargarMas} = useRecuperarColleccionListeningProg({
        col: 'tours',
        numero: 9,
        orden: 'nombre',
        wheres: wheres
    })


    useEffect(() => {

        if (seleccionado.nombre !== 'Todos') {
            setWheres([where('categoria', '==', seleccionado.nombre)])
        } else {
            setWheres([])
        }

    }, [seleccionado]);

    useEffect(() => {

        if (parms && parms.id) {

            irArriba()

            let index = CATEGORIAS.findIndex((e) => e.nombre === parms.id)
            if (index > -1) {
                setSeleccionado(CATEGORIAS[index])
            }

        }

    }, [parms])
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Tours_Portada seleccionado={seleccionado} setSeleccionado={setSeleccionado}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 10}}>
                <Tours_Catalogo seleccionado={seleccionado} data={data} setSeleccionado={setSeleccionado}
                                cargarMas={cargarMas}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: !masSM ? 12 : 46}}>
                <Asesorate/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 0}}>
                <Equipo/>
            </Grid>


        </Grid>
    )

}
export default Seccion_Tours